import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { CButton } from '@appcues/component-library';
import useToggle from 'next/hooks/use-toggle';
import CoolTip from 'components/Common/CoolTip';
import { recalculate } from 'actions/account/segmentMemberships';
import { asPromised } from 'utils/as-promised';

export const RecalculateMembershipsButton = ({ onClick }) => {
  const [inFlight, toggleInFlight] = useToggle();

  const handleClick = () => {
    toggleInFlight();
    onClick().then(toggleInFlight).catch(toggleInFlight);
  };

  return (
    <CoolTip
      position="bottom"
      disabled={!inFlight}
      tip="This may take several minutes"
    >
      <CButton onClick={handleClick} disabled={inFlight}>
        {inFlight ? 'Updating stats...' : 'Update stats'}
      </CButton>
    </CoolTip>
  );
};

RecalculateMembershipsButton.propTypes = {
  onClick: PropTypes.func,
};

const mapDispatchToProps = dispatch => ({
  onClick: () => asPromised(dispatch, recalculate()),
});

export default connect(null, mapDispatchToProps)(RecalculateMembershipsButton);
